module.exports = __webpack_public_path__ + "img/thumbnail_KirksDikDik_f_normal.057756a5.png";